import { render, staticRenderFns } from "./ResetNewPasswordView.vue?vue&type=template&id=5573c665&scoped=true"
import script from "./ResetNewPasswordView.vue?vue&type=script&lang=js"
export * from "./ResetNewPasswordView.vue?vue&type=script&lang=js"
import style0 from "./ResetNewPasswordView.vue?vue&type=style&index=0&id=5573c665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5573c665",
  null
  
)

export default component.exports